import React from 'react';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import { FragmentConfiguration } from '@/config';
import { useProduct, useRating } from '../ProductContext';

export const SchemaOrg = () => {
  const { product } = useProduct();
  const { rating } = useRating();
  const { company, api } = useConfig<FragmentConfiguration>();
  if (!product || !rating) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { name = '', images, attributes, slug, akl, brand = { name: '' }, price } = product;

  const descriptionValues = attributes?.description?.values;
  const longDescription = descriptionValues
    .map((value) => (value.type === 'longDescription' ? value.values : ''))
    .join('');
  const host =
    typeof window !== 'undefined'
      ? `${window?.location?.protocol}//${window?.location?.hostname}`
      : api.clientHost;
  return (
    <script
      type="application/ld+json"
      id="schemaorg-product"
      data-testid="schemaorg-product"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: `{
          "@context": "http://schema.org/",
          "@type": "Product",
          "name": "${name.replace(/"/g, '&quot;')}",
          "image": "${images[0]}/${slug}.jpg",
          "description": "${longDescription.replace(/"/g, '&quot;')}",
          "sku": "${akl}",
          "brand": {
            "@type": "Thing",
            "name": "${brand.name.replace(/"/g, '&quot;')}"
          },
          ${
            rating.product?.reviewCount > 0
              ? `"aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "${rating.product?.avgRating}",
            "reviewCount": "${rating.product?.reviewCount}",
            "bestRating": 5,
            "worstRating": 1
          },`
              : ''
          }
          "offers": {
            "@type": "Offer",
            "priceCurrency": "${price?.currency}",
            "price": "${(price?.value / 100).toFixed(2)}",
            "itemCondition": "http://schema.org/NewCondition",
            "availability": "http://schema.org/InStock",
            "url": "${host}/p/${slug}/${akl}",
            "seller": {
              "@type": "Organization",
              "name": "${company.name}"
            }
          }
        }`,
      }}
    />
  );
};

export default SchemaOrg;
